import { engineComponent, NumberUtils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Settings } from "./Settings";
import { WinAnimatorExtended } from "./WinAnimatorExtended";
import { Symbols } from "../GameComponents/Symbols";
import { PaylinesExtended } from "./PaylinesExtended";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { BaseView } from "../GameComponents/Base/BaseView";
import { FreespinsView } from "../GameComponents/Freespins/FreespinsView";
import { Symbol } from "../GameComponents/Symbol";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { ModuleManager } from "../Managers/ModuleManager";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { PlayList } from "../Components/Sounds/PlayList";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimatorExtendedFS extends WinAnimatorExtended {}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimatorExtendedFS.ts
 **/